import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import ScanProgressOverlay from "./ScanProgressOverlay";
import React from "react";
import {
  specsheetCloseScanReview,
  specsheetResumeScan,
} from "./specsheet.redux";

/**
 * What happens between "read this photo" and the review screen.
 *
 * Mounted on a bowler's sheet, it does two things and no more: it shows the
 * spinner while the server reads, and when a read comes back it sends the
 * operator to the review at that job's address.
 *
 * It used to hold the review itself, as a modal over the sheet. The review is
 * a screen now, so what is left here is the handoff -- and being always
 * mounted still makes this the right place to reattach to a scan that
 * outlived a page reload.
 */
const ScanHandoff = ({
  bowlerID,
  jobId,
  ready,
  scanning,
  onResume,
  onHandedOver,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    onResume();
    // Once per mount: a reload is the only way to get here with a job pending.
  }, [onResume]);

  useEffect(() => {
    if (!ready || !jobId || !bowlerID) return;
    // Cleared as we go, so coming back from the review does not bounce
    // straight into it again.
    onHandedOver();
    navigate(`/bowler/${bowlerID}/scan/${jobId}`);
  }, [ready, jobId, bowlerID, navigate, onHandedOver]);

  return <ScanProgressOverlay show={scanning} />;
};

const mapState = (state) => ({
  scanning: state.specsheet.savingPhotoAI,
  ready: state.specsheet.showScanReview,
  jobId: state.specsheet.scanJobId,
});

const mapDispatch = (dispatch) => ({
  onResume: () => dispatch(specsheetResumeScan()),
  onHandedOver: () => dispatch(specsheetCloseScanReview()),
});

export const ScanHandoffContainer = connect(mapState, mapDispatch)(ScanHandoff);

export default ScanHandoffContainer;
